export const GLOBAL_STATE = 'Work-Plan'

export const WORK_PLAN_CREATE = 'WORK_PLAN_CREATE' as const
export const WORK_PLAN_DELETE = 'WORK_PLAN_DELETE' as const
export const WORK_PLAN_ASSIGNED_ALL = 'WORK_PLAN_ASSIGNED_ALL' as const
export const WORK_PLAN_CREATED_ALL = 'WORK_PLAN_CREATED_ALL' as const
export const WORK_PLAN_UPDATE = 'WORK_PLAN_UPDATE' as const
export const WORK_PLAN_UPDATE_STATUS = 'WORK_PLAN_UPDATE_STATUS' as const
export const WORK_PLAN_STAFF_LIST = 'WORK_PLAN_STAFF_LIST' as const
